export const COMPLETE_PARTIAL = 'COMPLETE_PARTIAL';
export const COMPLETE_PARTIAL_SUCCESS = 'COMPLETE_PARTIAL_SUCCESS';
export const COMPLETE_PARTIAL_ERROR = 'COMPLETE_PARTIAL_ERROR';
export const COMPLETE_PARTIAL_INITIAL = 'COMPLETE_PARTIAL_INITIAL';

export interface CompletePartialRequest {
    email: string;
    firstName: string;
    lastName: string;
    messageChannelType: string;
    phone: string;
    salesChannelId?: number;
    signupToken: string;
    id: string;
    source?: string;
    graduationYear?: number;
    graduationMonth?: number;
}

export interface CompletePartialResponse {
    subscribed?: boolean;
    isPaid?: boolean;
    isClaimed?: boolean;
    email?: string;
    phone?: string;
    countryCode?: string;
    firstName?: string;
    lastName?: string;
    shortCodeSignup?: boolean;
    source?: string;
    campaign?: string;
    salesChannelId: number;
    emailToken?: string;
    signupToken?: string;
    createdAt?: string;
    id: string;
}

export interface CompletePartialError {
    body?: {
        message?: string;
        status?: string;
    };
    message?: string;
    name?: string;
    status?: number;
}

export interface CompletePartialState {
    data: CompletePartialResponse | null;
    loading: boolean;
    error: CompletePartialError | null;
}

export interface SetCompletePartialInitialAction {
    type: typeof COMPLETE_PARTIAL_INITIAL;
}
export interface CompletePartialStartAction {
    type: typeof COMPLETE_PARTIAL;
}

export interface CompletePartialSuccessAction {
    type: typeof COMPLETE_PARTIAL_SUCCESS;
    payload: CompletePartialResponse;
}

export interface CompletePartialErrorAction {
    type: typeof COMPLETE_PARTIAL_ERROR;
    payload: CompletePartialError;
}

export type CompletePartialAction =
    | CompletePartialStartAction
    | CompletePartialSuccessAction
    | CompletePartialErrorAction
    | SetCompletePartialInitialAction;
